"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = exports.StoreHooks = exports.StoreState = void 0;
const tslib_1 = require("tslib");
const core_common_1 = require("@smallstack/core-common");
const utils_1 = require("@smallstack/utils");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
var StoreState;
(function (StoreState) {
    StoreState["INITIAL"] = "initial";
    StoreState["LOADING"] = "loading";
    StoreState["LOADED"] = "loaded";
    StoreState["ERROR"] = "error";
})(StoreState = exports.StoreState || (exports.StoreState = {}));
var StoreHooks;
(function (StoreHooks) {
    StoreHooks["BEFORE_RESET"] = "beforeReset";
    StoreHooks["AFTER_RESET"] = "afterReset";
    StoreHooks["BEFORE_UPDATE_VALUE"] = "beforeUpdateValue";
    StoreHooks["AFTER_UPDATE_VALUE"] = "afterUpdateValue";
})(StoreHooks = exports.StoreHooks || (exports.StoreHooks = {}));
class Store {
    constructor(initialValue) {
        this.initialValue = initialValue;
        this.storeHooks = {};
        this._state$ = new rxjs_1.BehaviorSubject(StoreState.INITIAL);
        this._error$ = new rxjs_1.BehaviorSubject(undefined);
        this._value$ = new rxjs_1.BehaviorSubject(undefined);
        if (initialValue)
            this.setValue(initialValue, false);
    }
    setState(state) {
        this._state$.next(state);
    }
    setError(error) {
        core_common_1.Logger.error("Store", "Error in Store: ", error);
        this.setState(StoreState.ERROR);
        this._error$.next(error);
    }
    setValue(value, setLoaded = true) {
        if (value instanceof Promise) {
            try {
                value.then((v) => this.setValue(v, setLoaded)).catch((e) => this.setError(e));
            }
            catch (e) {
                this.setError(e);
            }
        }
        else {
            // TODO: deactivated until we find a solution to make store data immutable
            // Only update if value is different
            // if (!Utils.equals(this._value$.value, value))
            this._value$.next(value);
            // else Logger.info("Store", "Not setting new value since values are equal!", { original: this._value$.value, new: value });
            if (setLoaded === true)
                this.setState(StoreState.LOADED);
        }
    }
    updateValue(updateFn, setLoaded) {
        this.setValue(updateFn((0, utils_1.clone)(this._value$.getValue())), setLoaded);
    }
    setLoading() {
        this.setState(StoreState.LOADING);
        return this;
    }
    get state$() {
        return this._state$.asObservable();
    }
    get state() {
        return this._state$.getValue();
    }
    get value$() {
        return this._value$.asObservable();
    }
    get value() {
        return this._value$.getValue();
    }
    get error$() {
        return this._error$.asObservable();
    }
    get isLoading$() {
        return this.state$.pipe((0, operators_1.map)((state) => state === StoreState.LOADING));
    }
    get isLoaded$() {
        return this.state$.pipe((0, operators_1.map)((state) => state === StoreState.LOADED));
    }
    waitForLoaded() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.waitForExpectedValue)(this.state$, StoreState.LOADED);
        });
    }
    get hasError$() {
        return this.error$.pipe((0, operators_1.map)((error) => error !== undefined));
    }
    acknowledgeError() {
        this._error$.next(undefined);
    }
    reset() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.executeHooks(StoreHooks.BEFORE_RESET);
            this._error$.next(undefined);
            this._value$.next(this.initialValue);
            this.setState(StoreState.INITIAL);
            yield this.executeHooks(StoreHooks.AFTER_RESET);
        });
    }
    addHook(hookName, fn) {
        if (this.storeHooks[hookName] === undefined)
            this.storeHooks[hookName] = [];
        this.storeHooks[hookName].push(fn);
    }
    executeHooks(hookName, ...args) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.storeHooks[hookName] instanceof Array) {
                for (const hookFn of this.storeHooks[hookName]) {
                    yield hookFn(...args);
                }
            }
        });
    }
}
exports.Store = Store;
